import React from 'react';
import {connect} from "react-redux";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import RaisedButton from 'material-ui/RaisedButton';
import AuthService from "../../../../../../services/AuthService";
import {
    getImpactPerspectives
}from './../../../../../../actions/entreprise/actions_entreprise_entretien';

class PerspectivesForm extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            id_perspective:'',
            impact:'',
            id_echeance:''
        };
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleSubmit(){
        if(this.state.id_echeance && this.state.id_perspective && this.state.impact){
            this.Auth.fetch('/salarie/impact_perspectives',{
                method:'POST',
                data:{...this.state, id_entretien:this.props.id_entretien}
            }).then(x => {
                alert('Enregistrement avec succès.');
                this.props.dispatch(getImpactPerspectives(this.props.id_entretien))
            });
        }else{
            alert('Veuillez remplir tous les champs demandés.');
        }

    }

    render() {
        const perspectives = this.props.perspectives;
        return (
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >
                <SelectField
                    value={this.state.id_perspective}
                    fullWidth={true}
                    floatingLabelText="Perspective d'évolution"
                    onChange={(x, y, z)=>this.handleChange({target:{name:'id_perspective'}}, z)}
                    maxHeight={400}
                >
                    {perspectives.map(x => <MenuItem key={x.id} value={x.id} primaryText={x.perspective}/>)}
                </SelectField>
                <TextValidator
                    value={this.state.impact}
                    onChange={this.handleChange}
                    fullWidth={true}
                    name='impact'
                    type="text"
                    validators={['required', 'trim']}
                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                    floatingLabelText="Impact sur le métier du salarié"
                />
                <SelectField
                    value={this.state.id_echeance}
                    fullWidth={true}
                    floatingLabelText="Échéance de l'impact"
                    onChange={(x, y, z)=>this.handleChange({target:{name:'id_echeance'}}, z)}
                    maxHeight={400}
                >
                    {this.props.params_echeances.map(x => <MenuItem key={x.id} value={x.id} primaryText={x.echeance}/>)}
                </SelectField>
                <RaisedButton
                    style={{marginTop:25}}
                    secondary={true}
                    label={'Ajouter'}
                    type={'submit'}/>
            </ValidatorForm>
        );
    }
}

function mapStateToProps(store) {
    return {
        perspectives: store.entreprise.perspectives,
        params_echeances: store.params.echeances,
        id_entretien: store.entretien.header.id
    }
}

export default connect(mapStateToProps)(PerspectivesForm);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/PerspectivesForm.js